import "./App.css"
import { Route, Routes } from "react-router-dom"
import NotFound from "./components/common/NotFound"
import MyPage from "./pages/User/MyPage"
import QuizPage from "./pages/QuizPage"
import SignupPage from "./pages/User/SignupPage"
import ThemaPage from "./pages/System/ThemaPage"
import LoginPage from "./pages/User/LoginPage"
import ForgetPWPage from "./pages/User/ForgetPWPage"
import ViewItemPage from "./pages/System/ViewItemPage"
import ViewCodebook from "./pages/System/ViewCodebook"
import UploadPage from "./pages/System/UploadPage"
import QuizResultPage from "./pages/Quiz/QuizResultPage"
import VisaulizePage from "./pages/System/VisaulizePage"
import TopicPage from "./pages/System/TopicPage"
import ViewProfilePage from "./pages/System/ViewProfilePage"
import UpdatePage from "./pages/System/UpdatePage"
import Privacy from "./components/common/Privacy"
import Service from "./components/common/Service"
import useAccessToken from "./hooks/useAccessToken"
import MainPage from "./pages/MainPage"

function App() {
  useAccessToken()
  return (
    <>
      <Routes>
        <Route path="/*" element={<NotFound />} />
        <Route path="/" element={<MainPage />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/quiz/result" element={<QuizResultPage />} />

        <Route path="/user/signup" element={<SignupPage />} />
        <Route path="/user/login" element={<LoginPage />} />
        <Route path="/user/findpw" element={<ForgetPWPage />} />
        <Route path="/user/mypage" element={<MyPage />} />
        <Route
          path="/admin/system/view/profile"
          element={<ViewProfilePage />}
        />
        <Route path="/admin/system/view/item" element={<ViewItemPage />} />
        <Route path="/admin/system/view/codebook" element={<ViewCodebook />} />
        <Route path="/admin/system/thema" element={<ThemaPage />} />
        <Route path="/admin/system/upload" element={<UploadPage />} />
        <Route path="/admin/system/update" element={<UpdatePage />} />
        <Route path="/admin/system/visualize" element={<VisaulizePage />} />
        <Route path="/admin/system/tpc-modeling" element={<TopicPage />} />

        <Route path="policy/privacy" element={<Privacy />} />
        <Route path="policy/service" element={<Service />} />
      </Routes>
    </>
  )
}

export default App
